export default class PromiseQueue {
  constructor(opts) {
    const {
      maxQueued = 2
    } = opts || {};
    this.maxQueued = Math.min(maxQueued, 2);
    this.queue = [];
    this.thens = [];
    this.catches = [];
  }
  push(promFunc) {
    if (this.queue.length === this.maxQueued) {
      this.queue[this.maxQueued - 1] = promFunc;
      return;
    }
    if (this.queue.length === 0) {
      this.queue.push(promFunc);
      this.execPromise(promFunc);
    }
  }
  execPromise(promFunc) {
    const p = promFunc();
    const dequeueProm = res => {
      this.queue.shift();
      if (this.queue.length > 0) {
        this.execPromise(this.queue[0]);
      }
      return res;
    };
    if (p.then) {
      p.then(dequeueProm).then(res => {
        this.notifyThens(res);
      }).catch(err => {
        console.error(err);
        this.notifyCatches(err);
      });
    } else {
      dequeueProm();
    }
  }
  then(callback) {
    this.thens.push(callback);
    return this;
  }
  catch(callback) {
    this.catches.push(callback);
    return this;
  }
  notifyThens(res) {
    this.thens.forEach(then => then(res));
  }
  notifyCatches(err) {
    this.catches.forEach(c => c(err));
  }
}